/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOverviewPageTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2V2zm2 2v16h10V4H4zm12 0v16h4V4h-4zm-6 4H5V6h5v2zm3 0h-2V6h2v2zm6 0h-2V6h2v2zm-9 4H5v-2h5v2zm3 0h-2v-2h2v2zm6 0h-2v-2h2v2zm-9 4H5v-2h5v2zm3 0h-2v-2h2v2zm6 0h-2v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOverviewPageTemplate as OverviewPageTemplate };
